import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ISegment, ISegmentInformation } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { faCaretRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export interface ISegmentSelect {
    selectedSegment: string[];
    quoteId?: string;
}

export interface ISegmentSelectEmission {
    index: number;
    journeyId: string;
    quoteId?: string;
}

@Component({
    selector: 'all-segment-list',
    template: `
        <div class="segment-list"
             *ngIf="segmentList"
             [class.only-one]="segmentList.length === 1"
             [class.two]="segmentList.length === 2"
             [class.several]="segmentList.length > 2">
            <div *ngFor="let segment of segmentList;trackBy: tracker; let i = index"
                 class="segment-list-wrapper">
                <segment [segmentItem]="segment[segment.journey[0]]" type="journeyList"></segment>
                <div class="sector-list booking-marker"
                     *ngFor=" let journeyId of (segment | sortSegment);trackBy: tracker"
                     [class.booking-selected]="journeyId === selectedSegment[i]"
                     (click)="select(i, journeyId)">
                    <fa-icon [icon]="iconCaretRight" *ngIf="journeyId === selectedSegment[i]"></fa-icon>
                    <div class="sector-wrapper">
                        <div class="sector-cols">
                            <div class="sector-col">
                                <sector *ngFor="let sectorItem of segment[journeyId].sector"
                                        [sectorItem]="sectorItem"
                                        [selectedSector]="segment[selectedSegment[i]].sector"
                                        type="journeyList"></sector>
                            </div>
                            <div>
                                <carbon-footprint [carbonValue]="segment[journeyId].carbonFootprint"
                                                  [referenceValue]="segment[selectedSegment[i]].carbonFootprint"></carbon-footprint>
                                <div *permissionIf="'iqba.quote.rating.youcangoo.view'" class="yucangoo-container">
                                    <yucangoo-rating [rating]="segment[journeyId].rating"
                                                     [showAverage]="false"
                                                     [referenceRating]="segment[selectedSegment[i]].rating"></yucangoo-rating>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>`,
    styleUrls: ['./segment-list.scss'],
})
export class AllSegmentListComponent {
    @Input()
    public segmentList: ISegment[];
    @Input()
    public selectedSegment: string[];

    @Output()
    public readonly onSelect: EventEmitter<ISegmentSelectEmission> = new EventEmitter();

    public iconCaretRight: IconDefinition = faCaretRight;

    public tracker(index: number): number {
        return index;
    }

    public select(index: number, journeyId: string): void {
        this.onSelect.emit({index, journeyId});
    }
}
